import React from "react";
import LogoIcon from "assets/thmanyah-logo.svg";
function Logo({ width }) {
  return (
    <div>
      <img src={LogoIcon} alt="Logo" style={{ width: width + "rem" }} />
    </div>
  );
}

export default Logo;
